import { createWebappRoute, getRouter } from '../helpers';

export default [
  createWebappRoute({
    path: '/video',
    name: 'video-module',
    component() {
      console.log('ROUTER, video');

      $dt.showTutorialVideo();
      getRouter().push({ name: 'home-module' });

      return {};
    },
  }),
];
